import { ReactNode, forwardRef } from 'react';
import { cn } from 'v5/platform/dom/cn';

export interface ButtonGroupProps extends React.HTMLAttributes<HTMLDivElement> {
  orientation?: 'horizontal' | 'vertical';
  children: ReactNode;
}

export const ButtonGroup = forwardRef<HTMLDivElement, ButtonGroupProps>(
  ({ orientation = 'horizontal', children, className, ...rest }, ref) => {
    const isHorizontal = orientation === 'horizontal';

    const shared = '[&>*]:relative [&>*]:focus:z-10 [&>*]:focus-visible:ring-2';

    const horizontalSpecific = cn(
      'flex-row',
      '[&>*:not(:first-child)]:-ml-px',
      '[&>*:not(:first-child)]:rounded-l-none',
      '[&>*:not(:last-child)]:rounded-r-none'
    );

    const verticalSpecific = cn(
      'flex-col',
      '[&>*:not(:first-child)]:-mt-px',
      '[&>*:not(:first-child)]:rounded-t-none',
      '[&>*:not(:last-child)]:rounded-b-none'
    );

    return (
      <div
        ref={ref}
        className={cn(
          'inline-flex isolate',
          shared,
          isHorizontal ? horizontalSpecific : verticalSpecific,
          className
        )}
        {...rest}
      >
        {children}
      </div>
    );
  }
);
ButtonGroup.displayName = 'ButtonGroup';
